(() => {
  const initMatchingVariants = (root) => {
    if (!root) return;

    const panels = Array.from(root.querySelectorAll('[data-matching-variants-panel]'));
    const initialVariantId = root.dataset.initialVariantId;

    const showPanelForVariant = (variantId) => {
      if (!variantId) return;

      let activePanel = null;

      panels.forEach((panel) => {
        const isActive = String(panel.dataset.sourceVariantId) === String(variantId);
        const hasCarousel = panel.querySelector('[data-matching-variants-carousel]') !== null;
        const hasItems = panel.querySelectorAll('.matching-variants__item').length > 0;

        if (isActive && hasCarousel && hasItems) {
          panel.hidden = false;
          activePanel = panel;
        } else {
          panel.hidden = true;
        }
      });
      panels.forEach((panel) => {
        const carousel = panel.querySelector('[data-matching-variants-carousel]');
        if (!carousel || carousel.tagName !== 'SCROLL-CAROUSEL') return;

        const progress = panel.querySelector('.matching-variants__scrollbar-progress');
        if (!progress) return;

        const scrollbarContainer = panel.querySelector('.matching-variants__scrollbar');

        const updateScrollbar = () => {
          const maxScroll = carousel.scrollWidth - carousel.clientWidth;

          if (maxScroll <= 2) {
            if (scrollbarContainer) scrollbarContainer.hidden = true;
            return;
          }

          if (scrollbarContainer) scrollbarContainer.hidden = false;

          const scrollRatio = carousel.scrollLeft / maxScroll;
          const trackWidth = progress.parentElement.clientWidth;
          const thumbWidth = Math.min(150, trackWidth);
          const travelPx = trackWidth - thumbWidth;

          progress.style.width = `${thumbWidth}px`;
          progress.style.transform = `translateX(${scrollRatio * travelPx}px)`;
        };

        carousel.addEventListener('scroll', updateScrollbar, { passive: true });
        window.addEventListener('resize', updateScrollbar);
        updateScrollbar();
      });

      root.hidden = activePanel === null;
    };

    panels.forEach((panel) => {
      const carousel = panel.querySelector('[data-matching-variants-carousel]');
      if (!carousel) return;

      const itemCount = carousel.querySelectorAll('.matching-variants__item').length;
      if (itemCount <= 2) {
        carousel.setAttribute('data-cols', String(itemCount));
      }
    });

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.id) return;
      showPanelForVariant(variant.id);
    });

    document.addEventListener('cart:change', (e) => {
      if (!e.detail || !e.detail.cart) return;
      const inCart = new Set((e.detail.cart.items || []).map(item => String(item.variant_id)));
      document.querySelectorAll('[data-add-to-cart-btn][data-variant-id]').forEach(btn => {
        if (btn.dataset.soldOut) return;
        const isInCart = inCart.has(btn.dataset.variantId);
        btn.classList.toggle('matching-variants__button--added', isInCart);
        const label = isInCart ? btn.dataset.addedText : btn.dataset.defaultText;
        if (label) btn.textContent = label;
      });
    });

    showPanelForVariant(initialVariantId);
  };

  document.querySelectorAll('[data-matching-variants]').forEach(initMatchingVariants);
})();